/**
 * GraphQL type definitions matching backend schema — search pillar.
 * Split from graphql/types.ts (issue #1409).
 */

export enum SearchableEntityType {
  Service = 'Service',
  Team = 'Team',
  BusinessCapability = 'BusinessCapability',
  Technology = 'Technology',
  DataDomain = 'DataDomain',
}

export interface SearchResult {
  entityId: string;
  entityType: SearchableEntityType;
  name: string;
  description: string | null;
  url: string;
}

export interface SearchResultsConnection {
  results: SearchResult[];
  totalCount: number;
  cursor: string | null;
}

// ─── Tags ─────────────────────────────────────────────────────────────────────
